import React from 'react';
import Phone from './Phone';

const points = [
  {
    title: 'Deals nær deg',
    text: 'Se ukens deal og tilbud fra stedene du allerede handler hos, med avstand og hvor lenge de varer.',
  },
  {
    title: 'Du ser hvor mange ganger du kan bruke den',
    text: 'Hver deal viser hvor mange bruk du har igjen. Når de er brukt opp, ligger den under Brukt.',
  },
  {
    title: 'Sveip for å aktivere',
    text: 'Vis skjermen i kassen. Personalet ser hvilken deal som er aktiv, og nedtellingen.',
  },
];

const Deals: React.FC = () => (
  <section id="deals" className="py-20 bg-gradient-to-b from-white to-rose-50">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="text-sm font-semibold tracking-[0.18em] text-rose-600 mb-3">DEALS</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
            Tilbud der du allerede har stemplet.
          </h2>
          <p className="text-xl text-gray-600 mb-10 leading-relaxed">
            Deals er tilbud fra Stempz-stedene: 2 for 1, prosent på bakst,
            gratis produkt. Du finner dem på hjemskjermen og under Deals.
          </p>
          <ul className="space-y-6">
            {points.map((point) => (
              <li key={point.title}>
                <h3 className="text-lg font-bold text-gray-900">{point.title}</h3>
                <p className="text-gray-600 mt-1 leading-relaxed">{point.text}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative flex justify-center min-h-[640px]">
          <Phone src="/images/deals.png" alt="Deals-fanen med aktive tilbud og brukte deals" />
          <div className="hidden md:block absolute -right-2 top-24 w-44 rotate-6">
            <img
              src="/images/deal-active.png"
              alt="Aktivert deal som vises til personalet"
              className="w-full rounded-[1.6rem] shadow-2xl ring-1 ring-black/10"
            />
          </div>
          <img
            src="/images/deal-detail.png"
            alt="Deal-detalj med vilkår, gyldighet og hvor mange bruk som er igjen"
            className="hidden lg:block absolute -left-10 bottom-0 w-48 rounded-[1.6rem] shadow-2xl ring-4 ring-white"
          />
        </div>
      </div>
    </div>
  </section>
);

export default Deals;
